import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=e060f1e6&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=e060f1e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e060f1e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e060f1e6')) {
      api.createRecord('e060f1e6', component.options)
    } else {
      api.reload('e060f1e6', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=e060f1e6&scoped=true", function () {
      api.rerender('e060f1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/upgradeBlacklistManage/components/edit.vue"
export default component.exports